;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dCard = require("./payment_categories/2dCard.vue");

var _dCard2 = _interopRequireDefault(_dCard);

var _Card = require("./payment_categories/Card.vue");

var _Card2 = _interopRequireDefault(_Card);

var _Banks = require("./payment_categories/Banks.vue");

var _Banks2 = _interopRequireDefault(_Banks);

var _eventBus = require("./eventBus");

var _MobileMoney = require("./payment_categories/MobileMoney.vue");

var _MobileMoney2 = _interopRequireDefault(_MobileMoney);

var _Wallet = require("./payment_categories/Wallet.vue");

var _Wallet2 = _interopRequireDefault(_Wallet);

var _vue = require("vue");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Card: _Card2.default,
    Banks: _Banks2.default,
    MobileMoney: _MobileMoney2.default,
    TwoDCard: _dCard2.default,
    Wallet: _Wallet2.default
  },
  props: {
    current_payment_method: {
      type: String,
      required: false,
      default: "mobile_money"
    },
    payment_gateways: {
      type: Object,
      required: false,
      default: []
    },
    request_type: {
      type: String,
      required: true,
      default: "invoice"
    },
    base_url: {
      type: String,
      required: true,
      default: ""
    },
    invoice: {
      type: Object,
      default: {}
    },
    callback_url: {
      type: String,
      default: ""
    },
    status_api_url: {
      type: String,
      default: ""
    },
    showSecond: {
      type: Boolean,
      default: true
    },
    handleShowSecond: {
      type: Function,
      default: function _default() {}
    },
    telcos_prefixes: {
      type: Array,
      required: true,
      default: []
    },
    topupAmount: {
      type: Number,
      default: 0
    },
    wallet_token: {
      type: String,
      required: true,
      default: ""
    },
    qrCode: {
      type: String,
      default: ""
    },
    afrinet_onboarding_url: {
      type: String,
      default: ""
    },
    route_master_card_to_mpgs: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentPaymentMethod: this.current_payment_method,
      isOpen: false,
      currentPage: "Select Payment",
      topupWalletMode: false,
      topupAndPay: false,
      base_url: null,
      currentAccount: null,
      customerId: null,
      notificationUrl: null
    };
  },
  created: function created() {
    var _this = this;

    _eventBus.eventBus.$on("topup-wallet-clicked", function (currentAccount, base_url, customerId) {
      _this.currentAccount = currentAccount;
      _this.topupWalletMode = true;
      _this.base_url = base_url;
      _this.customerId = customerId;
      _this.determineDefaultGateway();
    });

    _eventBus.eventBus.$on("topup-and-pay-wallet-clicked", function (currentAccount, notificationUrl, customerId, base_url) {
      _this.currentAccount = currentAccount;
      _this.topupWalletMode = true;
      _this.topupAndPay = true;
      _this.base_url = base_url;
      _this.customerId = customerId;
      _this.notificationUrl = notificationUrl;
      _this.determineDefaultGateway();
    });

    _eventBus.eventBus.$on("wallet-selected", function (currentAccount, notification_url, base_url, customerId, spotRates, invoice) {
      _this.base_url = base_url;
      _this.currentAccount = currentAccount;
      _this.customerId = customerId;
      _this.notificationUrl = notification_url;
      _this.invoice = invoice;
    });

    _eventBus.eventBus.$on("mobile-payment-method-selected", function (method, currentAccount) {
      _this.currentPaymentMethod = method;
      _this.currentPage = method.replace("_", " ").toUpperCase();
      _this.isOpen = false;
      _this.currentAccount = currentAccount;
    });
  },
  mounted: function mounted() {
    this.autoSelectPaymentMethod();
  },

  computed: {
    channels: function channels() {
      var _this2 = this;

      if (this.invoice) {
        return this.payment_gateways.filter(function (gateway) {
          return ["mpesa", "airtel", "tkash"].includes(gateway.label) && gateway.currency === _this2.invoice.currency;
        });
      }
    },
    banks: function banks() {
      return this.payment_gateways.filter(function (gateway) {
        return gateway.gateway_type === 'bank';
      });
    },
    cards: function cards() {
      var _this3 = this;

      return this.payment_gateways.filter(function (gateway) {
        if (_this3.invoice) {
          return gateway.gateway_type === 'card' && gateway.label === 'cardsv4' && gateway.currency === _this3.invoice.currency;
        } else {
          return gateway.gateway_type === 'card' && gateway.label === 'cardsv4';
        }
      });
    },
    wallets: function wallets() {
      var _this4 = this;

      return this.payment_gateways.filter(function (gateway) {
        return gateway.gateway_type === 'wallet' && gateway.currency === _this4.invoice.currency;
      });
    },
    twoDcard: function twoDcard() {
      var _this5 = this;

      return this.payment_gateways.find(function (gateway) {
        return gateway.gateway_type === 'card' && gateway.label === 'cardsv4_2d' && (!_this5.invoice || gateway.currency === _this5.invoice.currency);
      });
    },
    masterCardTwoDcard: function masterCardTwoDcard() {
      var _this6 = this;

      return this.payment_gateways.find(function (gateway) {
        return gateway.gateway_type === 'card' && gateway.label === 'mastercard_2d' && (!_this6.invoice || gateway.currency === _this6.invoice.currency);
      });
    },
    masterCardGateway: function masterCardGateway() {
      var _this7 = this;

      return this.payment_gateways.find(function (gateway) {
        return gateway.gateway_type === 'card' && gateway.label === 'mastercard' && (!_this7.invoice || gateway.currency === _this7.invoice.currency);
      });
    }
  },
  watch: {
    currentPaymentMethod: function currentPaymentMethod(newMethod) {
      if (newMethod !== "card") {
        _eventBus.eventBus.$emit("gateway-fees-updated", 0);
      }
    }
  },
  methods: {
    autoSelectPaymentMethod: function autoSelectPaymentMethod() {
      if (this.invoice.currency == "KES") {
        this.selectPaymentMethod('mobile_money');
      } else {
        this.selectPaymentMethod('card');
      }
    },
    selectPaymentMethod: function selectPaymentMethod(method) {
      _eventBus.eventBus.$emit("payment-method-selected", method);
      this.currentPaymentMethod = method;
      this.currentPage = method.replace("_", " ").toUpperCase();
      this.isOpen = false;
    },
    toggleMenu: function toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    determineDefaultGateway: function determineDefaultGateway() {
      var gateways = [];
      if (this.invoice.currency === "KES") {
        gateways = this.payment_gateways.filter(function (gateway) {
          return gateway.label === "mpesa" || gateway.label === "airtel" || gateway.label === "tkash";
        });
        if (gateways.length > 0) {
          this.selectPaymentMethod('mobile_money');
        } else {
          this.selectPaymentMethod('card');
        }
      } else if (this.invoice.currency === "USD") {
        var _gateways = this.payment_gateways.filter(function (gateway) {
          return gateway.label === "card" || gateway.label === "cardsv4" || gateway.label === "cardsv2";
        });
        if (_gateways.length > 0) {
          this.selectPaymentMethod('card');
        }
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSecond),expression:"showSecond"}],staticClass:"flex flex-col h-full"},[_c('div',{staticClass:"grid grid-cols-10 flex-col gap-4 sm:h-full"},[_c('div',{staticClass:"lg:hidden col-span-full"},[_c('button',{staticClass:"link text-[#3c65f5] hover:underline flex items-center gap-1 -ml-1 !font-semibold",on:{"click":_vm.handleShowSecond}},[_c('svg',{staticClass:"size-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M15.75 19.5 8.25 12l7.5-7.5"}})]),_vm._v("\n          Back\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-span-10 md:col-span-3 hidden pr-4 pb-4 md:flex flex-col gap-12 min-h-[600px] h-full pt-6"},[_c('div',{staticClass:"flex flex-col gap-3.5"},[(_vm.channels.length > 0)?_c('button',{staticClass:"px-3.5 py-2.5 rounded-md flex justify-start items-center gap-2 overflow-hidden text-sm font-medium font-['Lexend'] leading-normal hover:bg-[#ebf3ff] transition-colors duration-300",class:{
              'bg-[#ebf3ff] text-[#3c65f5]': _vm.currentPaymentMethod === 'mobile_money',
              'bg-transparent text-[#667085]': _vm.currentPaymentMethod !== 'mobile_money',
            },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('mobile_money')}}},[_vm._v("Mobile Money")]):_vm._e(),_vm._v(" "),(_vm.cards.length > 0)?_c('button',{staticClass:"px-3.5 py-2.5 rounded-md flex justify-start items-center gap-2 overflow-hidden text-sm font-medium font-['Lexend'] leading-normal hover:bg-[#ebf3ff] transition-colors duration-300",class:{
              'bg-[#ebf3ff] text-[#3c65f5]': _vm.currentPaymentMethod === 'card',
              'bg-transparent text-[#667085]': _vm.currentPaymentMethod !== 'card',
            },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('card')}}},[_vm._v("Card")]):_vm._e(),_vm._v(" "),(_vm.banks.length > 0)?_c('button',{staticClass:"px-3.5 py-2.5 rounded-md flex justify-start items-center gap-2 overflow-hidden text-sm font-medium font-['Lexend'] leading-normal hover:bg-[#ebf3ff] transition-colors duration-300",class:{
              'bg-[#ebf3ff] text-[#3c65f5]': _vm.currentPaymentMethod === 'banks',
              'bg-transparent text-[#667084]': _vm.currentPaymentMethod !== 'banks',
            },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('banks')}}},[_vm._v("Banks")]):_vm._e(),_vm._v(" "),(_vm.wallets.length > 0)?_c('button',{staticClass:"px-3.5 py-2.5 rounded-md flex justify-start items-center gap-2 overflow-hidden text-sm font-medium font-['Lexend'] leading-normal hover:bg-[#ebf3ff] transition-colors duration-300",class:{
              'bg-[#ebf3ff] text-[#3c65f5]': _vm.currentPaymentMethod === 'wallet',
              'bg-transparent text-[#667084]': _vm.currentPaymentMethod !== 'wallet',
            },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('wallet')}}},[_vm._v("Pay with wallet")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-span-10 md:col-span-3 hidden w-full"},[_c('div',{staticClass:"relative block text-left"},[_c('div',[_c('button',{staticClass:"input flex items-center justify-between",attrs:{"type":"button","id":"menu-button","aria-expanded":"true","aria-haspopup":"true"},on:{"click":_vm.toggleMenu}},[_c('span',{staticClass:"inline-block normal-case"},[_vm._v(_vm._s(_vm.currentPage))]),_vm._v(" "),_c('svg',{staticClass:"-mr-1 h-5 w-5 text-gray-400 transition-all",class:{ 'rotate-180': _vm.isOpen, 'rotate-0': !_vm.isOpen },attrs:{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true","data-slot":"icon"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z","clip-rule":"evenodd"}})])])]),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",attrs:{"role":"menu","aria-orientation":"vertical","aria-labelledby":"menu-button","tabindex":"-1"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"away",undefined,$event.key,undefined)){ return null; }_vm.isOpen = false}}},[_c('div',{staticClass:"py-1",attrs:{"role":"none"}},[(_vm.channels.length)?_c('button',{staticClass:"block px-4 py-2 text-sm text-gray-900",attrs:{"type":"button","role":"menuitem","tabindex":"-1","id":"menu-item-0"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('mobile_money')}}},[_vm._v("\n                Mobile Money\n              ")]):_vm._e(),_vm._v(" "),(_vm.cards.length)?_c('button',{staticClass:"block px-4 py-2 text-sm text-gray-900",attrs:{"type":"button","role":"menuitem","tabindex":"-1","id":"menu-item-2"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('card')}}},[_vm._v("\n                Card\n              ")]):_vm._e(),_vm._v(" "),(_vm.banks.length)?_c('button',{staticClass:"block px-4 py-2 text-sm text-gray-900",attrs:{"type":"button","role":"menuitem","tabindex":"-1","id":"menu-item-3"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('banks')}}},[_vm._v("\n                Banks\n              ")]):_vm._e(),_vm._v(" "),(_vm.wallets.length)?_c('button',{staticClass:"block px-4 py-2 text-sm text-gray-900",attrs:{"type":"button","role":"menuitem","tabindex":"-1","id":"menu-item-4"},on:{"click":function($event){$event.preventDefault();return _vm.selectPaymentMethod('wallet')}}},[_vm._v("\n                Pay with wallet\n              ")]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-span-10 md:col-span-7 pt-0 sm:pt-6 h-full"},[_vm._l((_vm.cards),function(gateway){return (_vm.currentPaymentMethod === 'card')?_c('div',{key:gateway.id,staticClass:"h-full"},[_c('Card',{attrs:{"amount_net":gateway.configs.amount_net,"gateway":gateway,"card_setup_url":gateway.configs.card_setup_url,"authentication_url":gateway.configs.authentication_url,"authorization_url":gateway.configs.authorization_url,"completion_url":gateway.configs.completion_url,"mpgs_api_url":gateway.configs.validation_url,"access_key":gateway.configs.access_key,"profile_id":gateway.configs.profile_id,"signed_field_names":gateway.configs.signed_field_names,"unsigned_field_names":gateway.configs.unsigned_field_names,"merchant_descriptor":gateway.configs.merchant_descriptor,"charges":gateway.configs.charges,"status_api_url":gateway.configs.status_api_url,"enrollment_url":gateway.configs.enrollment_url,"currency":_vm.invoice.currency,"amount_due":_vm.invoice.amount_net,"invoice_no":_vm.invoice.invoice_number,"bill_ref":_vm.invoice.client_invoice_ref,"callback_url":_vm.callback_url,"base_url":_vm.base_url,"topupWalletMode":_vm.topupWalletMode,"topupAndPay":_vm.topupAndPay,"invoice":_vm.invoice,"customer_id":_vm.customerId,"notification_url":_vm.notificationUrl,"topup_amount":_vm.topupAmount,"twoDcard":_vm.twoDcard,"wallet_token":_vm.wallet_token,"masterCardTwoDcard":_vm.masterCardTwoDcard,"masterCardGateway":_vm.masterCardGateway,"route_master_card_to_mpgs":_vm.route_master_card_to_mpgs}})],1):_vm._e()}),_vm._v(" "),(_vm.currentPaymentMethod === 'banks')?_c('Banks',{attrs:{"payment_gateways":_vm.banks,"callback_url":_vm.callback_url,"status_api_url":_vm.status_api_url,"invoice":_vm.invoice}}):_vm._e(),_vm._v(" "),(_vm.currentPaymentMethod == 'mobile_money')?_c('MobileMoney',{attrs:{"requestType":_vm.request_type,"baseUrl":_vm.base_url,"channels":_vm.channels,"invoice":_vm.invoice,"callback_url":_vm.callback_url,"status_api_url":_vm.status_api_url,"telcos_prefixes":_vm.telcos_prefixes,"topupAmount":_vm.topupAmount}}):_vm._e(),_vm._v(" "),_vm._l((_vm.wallets),function(gateway){return (_vm.currentPaymentMethod == 'wallet')?_c('div',{key:gateway.id},[_c('Wallet',{attrs:{"invoice":_vm.invoice,"qrCode":_vm.qrCode,"gateway":gateway,"afrinet_onboarding_url":_vm.afrinet_onboarding_url}})],1):_vm._e()})],2)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ae7a50d4", __vue__options__)
  } else {
    hotAPI.reload("data-v-ae7a50d4", __vue__options__)
  }
})()}